// Rutas y carpeta de assets de la home nueva (port de Claude Design · "Landing Page Salmeron").
// ASSETS: /public/landing/inicio/* (las 42 imágenes/SVG del diseño).
export const ASSETS = '/landing/inicio/';

// Destinos de la cabecera, el menú, "Ver más" de Tactic/Pest y las flechas de "Nuestras apps".
// /tactic y /pest son las páginas de cada app del diseño nuevo (src/ulture, UltureSite.tsx).
export const ROUTES = {
  'Landing Page Salmeron': '/',
  'Sobre Nosotros': '/sobre-nosotros',
  'Ulture Tactic': '/tactic',
  'Ulture Pest': '/pest',
  'Partners': '/partners',
  'Blog': '/blog',
  'Contacto': '/contacto',
};

// Webs de producto y página de pago ("directamente al pago": sección de precios de cada app).
export const APPS = {
  tactic: {
    web: 'https://ulturetactic.co/',
    pay: 'https://ulturetactic.co/#pricing',
    ios: 'https://apps.apple.com/es/app/ulture-tactic/id6767254729',
    android: 'https://play.google.com/store/apps/details?id=com.despia.tactic',
  },
  // pesticidasesulture.co redirige (302) a ulturepest.co: se enlaza el destino final.
  pest: {
    web: 'https://ulturepest.co/',
    pay: 'https://ulturepest.co/#pricing',
    ios: 'https://apps.apple.com/es/app/ulture-pest/id6761015705',
    android: 'https://play.google.com/store/apps/details?id=com.despia.ulturepest',
  },
};

export const PHONE = '+34638684896';
